import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const useOrganizations = (user, authLoading) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrganizations = useCallback(async () => {
    if (authLoading || !user) return;
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get('/api/organizations');
      setOrganizations(res.data);
    } catch (err) {
      console.error('Error fetching organizations:', err);
      setError('Failed to load organizations');
    } finally {
      setLoading(false);
    }
  }, [user, authLoading]);

  const createOrganization = async (formData) => {
    setLoading(true);
    try {
      await axios.post('/api/organizations', formData);
      fetchOrganizations();
      return true;
    } catch (err) {
      console.error('Error creating organization:', err);
      setError(err.response?.data?.msg || 'Error creating organization');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const assignOrgMember = async (orgId, userId, role) => {
    try {
      await axios.post(`/api/organizations/${orgId}/members`, { userId, role });
      fetchOrganizations();
      return true;
    } catch (err) {
      console.error('Error assigning org member:', err);
      return false;
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  return {
    organizations,
    loading,
    error,
    createOrganization,
    assignOrgMember,
    fetchOrganizations
  };
};
